import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link, ScrollRestoration } from 'react-router-dom';
import { Button } from 'react-bootstrap5';

import routes from 'app/routes';
import Table from 'components/new_ui/Table';

import columns from './columns';
import Summary from './Summary';

export default function Preview({ members }) {
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [showSummary, setShowSummary] = useState(false);

  return (
    <div className="content">
      <section>
        <h3>Preview</h3>

        <Table
          title=" "
          columns={columns}
          data={members}
          selectableRowSelected={(_row) => true}
          afterSelect={(selectedRows) => setSelectedMembers(selectedRows)}
        />
      </section>

      <footer className="d-flex d-sm-block justify-content-between">
        <Link
          to={routes.managers.members.index}
          className="btn btn-outline-primary"
        >
          Cancel
        </Link>

        <Button
          disabled={selectedMembers.length === 0}
          onClick={() => setShowSummary(true)}
        >
          Import
        </Button>
      </footer>

      <Summary
        show={showSummary}
        members={members.filter((member) => selectedMembers.includes(member['Work Email']))}
        cancelCallback={() => setShowSummary(false)}
      />

      <ScrollRestoration />
    </div>
  );
}

Preview.propTypes = {
  members: PropTypes.arrayOf(PropTypes.object).isRequired,
};
